export default {
    aboutPageTitle: "À propos de LinguaScore",
    aboutPageDescription: "Nous aidons les apprenants à obtenir les meilleurs scores aux examens de compétence linguistique grâce à " +
        "une préparation structurée, des tests blancs réalistes et un suivi clair de leurs progrès.",
    ourMissionTitle: "Notre mission",
    ourMissionDescription: "LinguaScore a pour mission de rendre la préparation aux tests de langue accessible et efficace. Que vous visiez l&apos;IELTS, le TOEFL, le TCF France ou le TCF Canada, nous " +
        "mettons à votre disposition les outils nécessaires — tests blancs, ressources et statistiques — pour vous préparer en toute confiance et atteindre le score visé.",
    whatWeStandForTitle:"Nos valeurs",
    whatWeStandForDescription:"Nos valeurs",
    aboutFeatures1Title: "Contenu de qualité",
    aboutFeatures1Description: "Nos supports d'entraînement et tests blancs sont conçus pour reproduire le format et le niveau de difficulté des examens réels.",
    aboutFeatures2Title: "Suivi clair de vos progrès",
    aboutFeatures2Description: "Suivez vos performances grâce aux statistiques et analyses pour savoir sur quoi concentrer vos efforts.",
    aboutFeatures3Title: "Apprentissage structuré",
    aboutFeature3Description: "Des fiches de cours aux tests complets, tout ce dont vous avez besoin au même endroit.",
    aboutFeatures4Title: "Conçu pour la réussite",
    aboutFeatures4Description: "Nous nous concentrons sur l'IELTS, le TOEFL, le TCF France et le TCF Canada afin de le faire avec excellence."
}
